<template>
  <div>
    <div class="text-center">
      <Button _key="btnArchive" title="Confirmar" color="white" backGroundColor="#453db4" size="small"
        :clicked="update" />
    </div>
  </div>
</template>
<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button.vue";

import { mapMutations, mapActions } from "vuex";

export default {
  name: "SupplierOrderArchive",
  props: {
    supplierOrder: String,
  },
  components: {
    Button,
  },
  data() {
    return { urlUpdate: "/api/v1/supplier/supplier-order/archive" };
  },
  methods: {
    ...mapActions("generic", ["putApi"]),
    ...mapMutations("generic", ["addEvent", "hideModal", "removeLoading"]),
    update() {
      let params = { url: this.urlUpdate, obj: { id: this.supplierOrder.id } };
      this.putApi(params).then((response) => {
        if (response.success) {
          this.addEvent({ name: "supplierOrderArchive" });
          this.hideModal();
        }
        this.removeLoading(["btnArchive"]);
      });
    },
  },
};
</script>